import script from "./AIMilitaryInterview.vue?vue&type=script&setup=true&lang=js"
export * from "./AIMilitaryInterview.vue?vue&type=script&setup=true&lang=js"

import "./AIMilitaryInterview.vue?vue&type=style&index=0&id=85699356&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85699356"]])

export default __exports__